import React from 'react';
import {
  Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Button,
} from '@mui/material';
import { useCloseOnBack } from '../../hooks/useCloseOnBack';

// 장비 삭제 확인창 — 목록(EqpListPanel)의 휴지통 아이콘과 상세창(EqpInfoTab)의 [삭제] 버튼이
// 공유한다. window.confirm 대신 화면 가운데 작은 창으로 띄우는 이유는 EqpAgentFormDialog의
// 삭제 확인창과 동일(모바일 웹뷰에서 window.confirm이 막히는 경우가 있었다).
const EqpDeleteConfirmDialog = ({ open, eqpNm, onCancel, onConfirm }) => {
  // 뒤로가기(Android): 확인창이 history 스택 위에 따로 쌓여서, 뒤로가기를 누르면
  // 확인창만 먼저 닫히고(상세창은 그대로) 한 번 더 누르면 상세창이 닫힌다.
  useCloseOnBack(open, onCancel);

  return (
    <Dialog open={open} onClose={onCancel} maxWidth="xs" fullWidth>
      <DialogTitle>장비 삭제</DialogTitle>
      <DialogContent>
        <DialogContentText>
          {`'${eqpNm || ''}'을(를) 삭제하면 통신 채널·현재 상태·공구 기준·매거진 설정이 함께 지워지고 `
            + '에이전트 수집도 멈춥니다. 수집 이력(이벤트·가공 프로그램 백업)은 남습니다.'}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onCancel}>취소</Button>
        <Button color="error" variant="contained" onClick={onConfirm}>삭제</Button>
      </DialogActions>
    </Dialog>
  );
};

export default EqpDeleteConfirmDialog;
